import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import { CourseContentPreview } from '@/components/courses/CourseContentPreview';
import { useCourse } from '@/hooks/query';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentUser } from '@/store/features/users/current-user.slice';
import { FlexContainer } from '@/ui/styled-ui';
import moment from 'moment';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

export const ContentPreviewPage: React.FC = () => {
  const { t } = useTranslation();
  const { id: courseId } = useParams();
  const currentUser = useAppSelector(selectCurrentUser);
  const navigate = useNavigate();
  const location = useLocation();

  const returnUrl = (location.state as { from?: string })?.from;

  // Fetch course data
  const { course, isLoading: isCourseLoading } = useCourse({
    courseId,
    staleTime: Infinity,
  });

  const canPreview = useMemo(() => {
    return (
      !course?.releaseDate ||
      course?.isPreviewable ||
      moment(course?.releaseDate).isBefore(moment(), 'day') ||
      currentUser?.account.isSystem
    );
  }, [
    course?.releaseDate,
    course?.isPreviewable,
    currentUser?.account.isSystem,
  ]);

  useEffect(() => {
    if (!canPreview && course && !isCourseLoading) {
      navigate(
        returnUrl ||
          RedirectPaths[RedirectPathsEnum.COURSES_CONTENT](course.id),
      );
    }
  }, [canPreview, course, isCourseLoading, navigate, returnUrl]);

  if (isCourseLoading || (course && !canPreview)) {
    return (
      <FlexContainer direction="column" className="h-full">
        <FlexContainer direction="column" className="mt-5 flex-1">
          <ProgressSpinner />
          <h3>{t('content.loading')}</h3>
        </FlexContainer>
      </FlexContainer>
    );
  }

  return course ? <CourseContentPreview course={course} /> : null;
};
